export const BrushUnderline = ({ children, className = "" }) => (
  <span className={`relative inline-block ${className}`}>
    <svg
      aria-hidden="true"
      className="absolute -bottom-1 left-0 h-[0.35em] w-full"
      viewBox="0 0 200 12"
      preserveAspectRatio="none"
    >
      <path
        d="M3 7 Q 40 2 98 5 T 197 3 L 197 9 Q 130 12 60 10 T 3 10 Z"
        fill="#F02F25"
      />
    </svg>
    <span className="relative">{children}</span>
  </span>
);

export default function BrushHeading({ eyebrow, children, dark = false, id }) {
  return (
    <div className="max-w-3xl">
      {eyebrow && (
        <p
          className={`mb-4 inline-flex items-center gap-2 rounded-full border-2 border-jet bg-cream px-4 py-1 text-xs font-bold uppercase tracking-[0.2em] shadow-hard-sm sm:text-sm ${
            dark ? "bg-jet text-amber border-cream" : ""
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        id={id}
        className={`font-display text-3xl font-black uppercase leading-[1.05] tracking-tight sm:text-5xl ${
          dark ? "text-cream" : "text-jet"
        }`}
      >
        {children}
      </h2>
    </div>
  );
}
